export default __webpack_public_path__ + "static/media/logo2.31345440.PNG";